import { Component, Input } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';
import { IncidentModalComponent } from '../modals/incident-modal/incident-modal.component';

@Component({
  selector: 'app-tr-incident-card',
  templateUrl: './tr-incident-card.component.html',
})
export class TrIncidentCardComponent {
  @Input() incident: any;
  constructor(protected readonly feUtil: FeUtil) { }

  emitCardClick(incident: any): void {
    this.feUtil.modalSvc.create<IncidentModalComponent>({
      nzContent: IncidentModalComponent,
      nzWidth: '900px',
      nzMaskClosable: true,
      nzClosable: true,
      nzData: incident,
      nzClassName: 'incident-modal',
      nzBodyStyle: { padding: '0' },
      nzStyle: { top: '20' },
      nzCloseOnNavigation: true
    });
  }
}
